/* Raveluno — interacciones y animaciones (sin librerías) */
(function () {
  'use strict';

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  /* ---------- Entradas al hacer scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-rv-reveal]:not(.is-visible), .rv-split:not(.is-visible), [data-rv-observar]:not(.is-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            observador.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { observador.observe(el); });
    // Red de seguridad: si se baja muy rápido o se salta con un enlace, mostrar lo que ya quedó atrás
    if (!window.rvRevisor) {
      window.rvRevisor = true;
      var pend = false;
      var revisar = function () {
        pend = false;
        var lim = window.innerHeight * 0.92;
        document.querySelectorAll('[data-rv-reveal]:not(.is-visible), .rv-split:not(.is-visible), [data-rv-observar]:not(.is-visible)').forEach(function (el) {
          if (el.getBoundingClientRect().top < lim) { el.classList.add('is-visible'); if (observador) observador.unobserve(el); }
        });
      };
      window.addEventListener('scroll', function () { if (!pend) { pend = true; setTimeout(function () { requestAnimationFrame(revisar); }, 120); } }, { passive: true });
      window.addEventListener('load', revisar);
    }
  }

  /* Escalonado: hijos con data-rv-reveal dentro de [data-rv-stagger] */
  function initStagger(root) {
    (root || document).querySelectorAll('[data-rv-stagger]').forEach(function (grupo) {
      var paso = parseFloat(grupo.getAttribute('data-rv-stagger')) || 0.1;
      grupo.querySelectorAll(':scope > [data-rv-reveal]').forEach(function (el, i) {
        el.style.setProperty('--rv-d', (i * paso).toFixed(2) + 's');
      });
    });
  }

  /* Titulares palabra a palabra */
  function initSplit(root) {
    (root || document).querySelectorAll('.rv-split:not([data-rv-hecho])').forEach(function (el) {
      el.setAttribute('data-rv-hecho', '1');
      var i = 0;
      function recorrer(nodo) {
        Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
          if (hijo.nodeType === 3) {
            var frag = document.createDocumentFragment();
            hijo.textContent.split(/(\s+)/).forEach(function (trozo) {
              if (!trozo) return;
              if (/^\s+$/.test(trozo)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'rv-palabra';
              var s = document.createElement('span'); s.textContent = trozo; s.style.setProperty('--i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            nodo.replaceChild(frag, hijo);
          } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') {
            recorrer(hijo);
          }
        });
      }
      recorrer(el);
    });
  }

  /* ---------- Parallax suave (hero, CTA) ---------- */
  function initParallax() {
    if (reducido) return;
    var items = document.querySelectorAll('[data-rv-parallax]');
    if (!items.length) return;
    var pendiente = false;
    function pintar() {
      pendiente = false;
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var f = parseFloat(el.getAttribute('data-rv-parallax')) || 0.15;
        var y = (r.top + r.height / 2 - vh / 2) * -f;
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(1.06)';
      });
    }
    window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }, { passive: true });
    pintar();
  }

  /* ---------- Foco de luz que sigue al cursor en tarjetas ---------- */
  function initFoco(root) {
    (root || document).querySelectorAll('[data-rv-foco]').forEach(function (el) {
      if (el.dataset.rvListo) return;
      el.dataset.rvListo = '1';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        el.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---------- Carrito: añadir y abrir el cajón de Dawn ---------- */
  function initCarrito(root) {
    (root || document).querySelectorAll('form[data-rv-atc]').forEach(function (form) {
      if (form.dataset.rvListo) return;
      form.dataset.rvListo = '1';
      form.addEventListener('submit', function (e) {
        var cajon = document.querySelector('cart-drawer');
        if (!window.fetch || !cajon || typeof cajon.renderContents !== 'function') return; // envío normal
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('is-cargando');
        var datos = new FormData(form);
        datos.append('sections', 'cart-drawer,cart-icon-bubble');
        datos.append('sections_url', window.location.pathname);
        var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
        fetch(url, { method: 'POST', body: datos, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { alert(res.description || res.message); return; }
            cajon.classList.remove('is-empty');
            cajon.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.classList.remove('is-cargando'); });
      });
    });
  }

  function formatoDinero(formato) {
    return function (c) {
      var v = (c / 100).toFixed(2);
      var miles = function (n) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
      var p = v.split('.');
      return (formato || '${{amount}}')
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, p[0] + ',' + p[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, miles(String(Math.round(c / 100))))
        .replace(/\{\{\s*amount\s*\}\}/, miles(p[0]) + '.' + p[1]);
    };
  }

  /* ---------- Garaje: elegir modelo en la portada ---------- */
  function initGaraje(root) {
    (root || document).querySelectorAll('[data-rv-garaje]').forEach(function (g) {
      if (g.dataset.rvListo) return;
      g.dataset.rvListo = '1';
      var fotos = g.querySelectorAll('.rv-garaje__foto');
      var botones = g.querySelectorAll('.rv-modelo');
      var nombre = g.querySelector('[data-rv-nombre]');
      var actualTxt = g.querySelector('[data-rv-actual]');
      var precio = g.querySelector('[data-rv-precio]');
      var antes = g.querySelector('[data-rv-antes]');
      var idInput = g.querySelector('input[name="id"]');
      var btnTexto = g.querySelector('[data-rv-btn-texto]');
      var btn = btnTexto ? btnTexto.closest('button') : null;
      var enlace = g.querySelector('[data-rv-enlace]');
      var dinero = formatoDinero(g.getAttribute('data-rv-moneda'));
      var txtComprar = btnTexto ? btnTexto.textContent : '';
      var txtAgotado = g.getAttribute('data-rv-agotado') || 'Sold out';
      var actual = 0, temporizador = null;
      var auto = parseInt(g.getAttribute('data-rv-auto'), 10) || 0;
      function ir(i, usuario) {
        if (!botones.length) return;
        i = (i + botones.length) % botones.length;
        actual = i;
        var b = botones[i];
        fotos.forEach(function (f, j) { f.classList.toggle('is-activa', j === i); });
        botones.forEach(function (x, j) { x.classList.toggle('is-activa', j === i); x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        if (nombre) {
          nombre.classList.add('is-cambiando');
          setTimeout(function () { nombre.textContent = b.getAttribute('data-nombre'); nombre.classList.remove('is-cambiando'); }, 220);
        }
        if (actualTxt) actualTxt.textContent = String(i + 1).padStart(2, '0');
        if (precio) precio.textContent = dinero(parseInt(b.getAttribute('data-precio'), 10));
        if (antes) {
          var ca = parseInt(b.getAttribute('data-antes'), 10) || 0;
          var pr = parseInt(b.getAttribute('data-precio'), 10) || 0;
          antes.hidden = !(ca > pr); antes.textContent = ca > pr ? dinero(ca) : '';
        }
        if (idInput) idInput.value = b.getAttribute('data-id');
        var disp = b.getAttribute('data-disponible') === 'true';
        if (btn) btn.disabled = !disp;
        if (btnTexto) btnTexto.textContent = disp ? txtComprar : txtAgotado;
        if (enlace) enlace.href = b.getAttribute('data-url') || (enlace.getAttribute('data-base') + '?variant=' + b.getAttribute('data-id'));
        if (usuario && b.scrollIntoView && window.innerWidth < 990) {
          var lista = b.closest('.rv-garaje__modelos');
          if (lista) lista.scrollTo({ left: b.parentElement.offsetLeft - 40, behavior: 'smooth' });
        }
        if (usuario) parar();
      }
      function parar() { if (temporizador) { clearInterval(temporizador); temporizador = null; } }
      botones.forEach(function (b, j) { b.addEventListener('click', function () { ir(j, true); }); });
      var p = g.querySelector('[data-rv-prev]'), n = g.querySelector('[data-rv-next]');
      if (p) p.addEventListener('click', function () { ir(actual - 1, true); });
      if (n) n.addEventListener('click', function () { ir(actual + 1, true); });
      var esc = g.querySelector('.rv-garaje__escenario');
      if (esc) {
        var tx = null;
        esc.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
        esc.addEventListener('touchend', function (e) {
          if (tx === null) return;
          var dx = e.changedTouches[0].clientX - tx;
          if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1), true);
          tx = null;
        });
      }
      if (auto > 0 && !reducido && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          if (e[0].isIntersecting && !temporizador && !g.dataset.rvTocado) {
            temporizador = setInterval(function () { ir(actual + 1); }, auto * 1000);
          } else if (!e[0].isIntersecting) { parar(); }
        }, { threshold: 0.4 }).observe(g);
        g.addEventListener('pointerdown', function () { g.dataset.rvTocado = '1'; parar(); });
      }
    });
  }

  /* ---------- Ambientes: scroll horizontal fijado ---------- */
  function initAmbientes(root) {
    (root || document).querySelectorAll('[data-rv-hscroll]').forEach(function (sec) {
      if (sec.dataset.rvListo) return;
      sec.dataset.rvListo = '1';
      var pista = sec.querySelector('.rv-ambientes__pista');
      var fijo = sec.querySelector('.rv-ambientes__fijo');
      var barra = sec.querySelector('.rv-ambientes__progreso');
      if (!pista || !fijo) return;
      var distancia = 0, pendiente = false;
      function medir() {
        if (window.innerWidth < 990 || reducido) { sec.style.height = ''; pista.style.transform = ''; distancia = 0; return; }
        distancia = Math.max(0, pista.scrollWidth - window.innerWidth);
        sec.style.height = (window.innerHeight + distancia) + 'px';
        pintar();
      }
      function pintar() {
        pendiente = false;
        if (!distancia) return;
        var r = sec.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, -r.top / (r.height - window.innerHeight)));
        pista.style.transform = 'translate3d(' + (-p * distancia).toFixed(1) + 'px,0,0)';
        if (barra) barra.style.setProperty('--p', p.toFixed(3));
      }
      window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }, { passive: true });
      window.addEventListener('resize', medir);
      window.addEventListener('load', medir);
      medir();
    });
  }

  /* ---------- Acordeón ---------- */
  function initAcordeon(root) {
    (root || document).querySelectorAll('[data-rv-acordeon]').forEach(function (grupo) {
      if (grupo.dataset.rvListo) return;
      grupo.dataset.rvListo = '1';
      var unico = grupo.getAttribute('data-rv-acordeon') === 'uno';
      grupo.querySelectorAll('.rv-acordeon__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.rv-acordeon__item');
          var abrir = !item.classList.contains('is-abierta');
          if (unico) grupo.querySelectorAll('.rv-acordeon__item.is-abierta').forEach(function (o) {
            o.classList.remove('is-abierta'); o.querySelector('.rv-acordeon__q').setAttribute('aria-expanded', 'false');
          });
          item.classList.toggle('is-abierta', abrir);
          btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-rv-producto]').forEach(function (sec) {
      if (sec.dataset.rvListo) return;
      sec.dataset.rvListo = '1';

      // Galería: las fotos cuyo texto alternativo empieza por "<Modelo> ·" solo se ven con ese modelo
      var slides = sec.querySelectorAll('.rv-galeria-p__slide');
      var minis = sec.querySelectorAll('.rv-galeria-p__mini');
      var grupoActual = sec.getAttribute('data-rv-grupo-sel') || '';
      var actual = Math.max(0, Array.prototype.findIndex.call(slides, function (sl) { return sl.classList.contains('is-activa'); }));
      function visible(el) { var c = el.getAttribute('data-rv-grupo') || ''; return !c || !grupoActual || c === grupoActual; }
      function indicesVisibles() { var r = []; slides.forEach(function (s, j) { if (visible(s)) r.push(j); }); return r; }
      function ir(i) {
        if (!slides.length) return;
        actual = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-activa', j === actual); });
        minis.forEach(function (m, j) { m.classList.toggle('is-activa', j === actual); m.setAttribute('aria-current', j === actual ? 'true' : 'false'); });
      }
      function mover(paso) {
        var vis = indicesVisibles(); if (!vis.length) return;
        var pos = vis.indexOf(actual); if (pos < 0) pos = 0;
        ir(vis[(pos + paso + vis.length) % vis.length]);
      }
      function filtrar(c) { grupoActual = c || ''; minis.forEach(function (m) { m.hidden = !visible(m); }); }
      minis.forEach(function (m, j) { m.addEventListener('click', function () { ir(j); }); });
      var p = sec.querySelector('[data-rv-g-prev]'), n = sec.querySelector('[data-rv-g-next]');
      if (p) p.addEventListener('click', function () { mover(-1); });
      if (n) n.addEventListener('click', function () { mover(1); });
      var principal = sec.querySelector('.rv-galeria-p__principal');
      if (principal) {
        var tx = null;
        principal.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (tx === null) return;
          var dx = e.changedTouches[0].clientX - tx;
          if (Math.abs(dx) > 40) mover(dx < 0 ? 1 : -1);
          tx = null;
        });
      }
      function handle(txt) {
        return String(txt || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      }
      var posGrupo = parseInt(sec.getAttribute('data-rv-grupo-pos'), 10) || 0;

      // Cantidad
      sec.querySelectorAll('.rv-cantidad').forEach(function (c) {
        var inp = c.querySelector('input');
        c.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = (parseInt(inp.value, 10) || 1) + (b.hasAttribute('data-mas') ? 1 : -1);
            inp.value = Math.max(1, v);
          });
        });
      });

      // Variantes
      var json = sec.querySelector('[data-rv-variantes]');
      if (json) {
        var variantes = JSON.parse(json.textContent);
        var precio = sec.querySelector('[data-rv-precio]');
        var antes = sec.querySelector('[data-rv-precio-antes]');
        var ahorro = sec.querySelector('[data-rv-ahorro]');
        var btnTexto = sec.querySelector('[data-rv-btn-texto]');
        var btn = btnTexto ? btnTexto.closest('button') : null;
        var dinero = formatoDinero(sec.getAttribute('data-rv-moneda'));
        var txtAgotado = sec.getAttribute('data-rv-agotado') || 'Sold out';
        var txtComprar = btnTexto ? btnTexto.textContent : '';
        sec.querySelectorAll('.rv-opcion input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var etiqueta = inp.closest('.rv-opcion').querySelector('[data-rv-opcion-valor]');
            if (etiqueta) etiqueta.textContent = inp.value;
            var sel = Array.prototype.map.call(sec.querySelectorAll('.rv-opcion'), function (f) {
              var c = f.querySelector('input:checked'); return c ? c.value : null;
            });
            var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
            if (!v) {
              if (btn) btn.disabled = true;
              if (btnTexto) btnTexto.textContent = txtAgotado;
              return;
            }
            sec.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = v.id; });
            if (precio) precio.textContent = dinero(v.price);
            sec.querySelectorAll('[data-rv-precio-barra]').forEach(function (b) { b.textContent = dinero(v.price); });
            var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
            if (antes) { antes.textContent = hayAntes ? dinero(v.compare_at_price) : ''; antes.hidden = !hayAntes; }
            if (ahorro) {
              ahorro.hidden = !hayAntes;
              if (hayAntes) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
            }
            if (btn) btn.disabled = !v.available;
            if (btnTexto) btnTexto.textContent = v.available ? txtComprar : txtAgotado;
            if (posGrupo > 0) filtrar(handle(v.options[posGrupo - 1]));
            var fotoBarra = sec.querySelector('.rv-barra__img img');
            if (fotoBarra && v.featured_media && v.featured_media.preview_image) {
              var src = v.featured_media.preview_image.src;
              fotoBarra.removeAttribute('srcset');
              fotoBarra.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            }
            var idx = -1;
            if (v.featured_media) idx = Array.prototype.findIndex.call(slides, function (s) { return s.getAttribute('data-media-id') == v.featured_media.id; });
            if (idx < 0) { var vis = indicesVisibles(); idx = vis.length ? vis[0] : 0; }
            ir(idx);
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          });
        });
      }

      // Barra fija de compra
      var barra = sec.querySelector('.rv-barra');
      var objetivo = sec.querySelector('.rv-compra__fila');
      if (barra && objetivo && 'IntersectionObserver' in window) {
        var footer = document.querySelector('.rv-footer, footer');
        var visibleObj = true, visibleFooter = false;
        var act = function () { barra.classList.toggle('is-visible', !visibleObj && !visibleFooter && objetivo.getBoundingClientRect().top < 0); };
        new IntersectionObserver(function (e) { visibleObj = e[0].isIntersecting; act(); }).observe(objetivo);
        if (footer) new IntersectionObserver(function (e) { visibleFooter = e[0].isIntersecting; act(); }).observe(footer);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () {
          var b = sec.querySelector('form[data-rv-atc] [type="submit"]');
          if (b && !b.disabled) b.click();
        });
      }
    });
  }

  function initTodo(root) {
    initSplit(root);
    initStagger(root);
    initReveal(root);
    initFoco(root);
    initGaraje(root);
    initAmbientes(root);
    initAcordeon(root);
    initCarrito(root);
    initProducto(root);
  }

  function arrancar() {
    window.rvListo = true;
    initTodo(document);
    initParallax();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  // Editor de Shopify: reiniciar cuando se edita una sección
  document.addEventListener('shopify:section:load', function (e) {
    initTodo(e.target);
    e.target.querySelectorAll('[data-rv-reveal], .rv-split, [data-rv-observar]').forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
